import React from 'react';
import PropTypes from 'prop-types';
import numeral from 'numeral';

import {
  ExtendedFlex,
  Heading,
  Link,
  Formatters,
} from '../../coreui';

import ReitContentItem from './ReitContentItem';
import ReitButtons from './ReitButtons';

const ReitIIContent = ({ data, invested }) => {
  const investedPage = data.overview.cashInvested.value > 0 ?
    'invested' : 'investment-opportunity';
  const recurringMonthly = data.autoinvestConfigs.reduce((accum, item) => {
    if (item.status !== 'active') {
      return accum;
    }
    return accum + item.requestedAmount;
  }, 0);
  return (
    <ExtendedFlex
      flexDirection="column"
      width="100%"
      py={[30, 50, 80]}
      px={[0, '2em']}
    >
      {
        !invested &&
        <>
          <Heading
            type="H9"
            my={0}
          >
            {data.title}
          </Heading>
          <Link
            type="L4"
            to={`/${investedPage}/${data.nid}`}
            mt="1em"
            mb="2em"
          >
            View Investment
          </Link>
        </>
      }
      <ExtendedFlex
        justifyContent="space-between"
        flexDirection={['column', 'row']}
      >
        <ExtendedFlex
          flexDirection="column"
          width={['100%', '46%']}
        >
          <ReitContentItem
            label="CURRENT INVESTMENT VALUE"
            value={data.overview.currentInvestmentValue.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.overview.currentInvestmentValue.tooltip}
            tooltipId="reitII:currentInvestmentValue"
          />
          <ReitContentItem
            label="TOTAL SHARES"
            value={data.overview.totalShares.value}
            valueFormat={Formatters.SHARES}
          />
          <ReitContentItem
            label="NAV PER SHARE"
            value={data.overview.currentNav.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.overview.currentNav.tooltip}
            tooltipId="reitII:navPerShare"
          />
          <ReitContentItem
            label="REIT DISTRIBUTION, ANNUALIZED"
            value={data.overview.distributionYieldToDate.value}
            valueFormat={Formatters.PERCENTAGE2}
            tooltipId="reitII:reitDistributionAnnualized"
            lastItem={!data.overview.sharesRedeemed.value}
          />
          {
            Boolean(data.overview.sharesRedeemed.value) &&
            <ReitContentItem
              label="NUMBER OF SHARES REDEEMED"
              value={data.overview.sharesRedeemed.value}
              lastItem={data.overview.sharesRedeemed.value}
            />
          }

        </ExtendedFlex>
        <ExtendedFlex
          flexDirection="column"
          width={['100%', '46%']}
        >
          <ReitContentItem
            label="CURRENT TOTAL INVESTED"
            value={data.overview.currentTotalInvested.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.overview.cashInvested.tooltip}
            tooltipId="reitII:cashInvested"
          />
          <ReitContentItem
            label="CASH INVESTED"
            value={data.overview.cashInvested.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
          />
          {
            recurringMonthly > 0 &&
            <ReitContentItem
              label="RECURRING AUTO INVESTMENT"
              value={`${numeral(recurringMonthly).format(Formatters.DOLLARS_DECIMALS)}/Mo`}
            />
          }
          <ReitContentItem
            label="DISTRIBUTIONS REINVESTED"
            value={data.overview.distributionsReinvested.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.overview.distributionsReinvested.tooltip}
            tooltipId="reitII:distributionsReinvested"
          />
          <ReitContentItem
            label="CASH DISTRIBUTIONS PAID"
            value={data.overview.cashDistributionsPaid.value}
            valueFormat={Formatters.DOLLARS_DECIMALS}
            tooltipText={data.overview.cashDistributionsPaid.tooltip}
            tooltipId="reitII:cashDistributionsPaid"
            lastItem={!data.overview.cashRedeemed.value}
          />
          {
            Boolean(data.overview.cashRedeemed.value) &&
            <ReitContentItem
              label="CASH REDEEMED"
              value={data.overview.cashRedeemed.value}
              valueFormat={Formatters.DOLLARS_DECIMALS}
              lastItem={data.overview.cashRedeemed.value}
            />
          }

        </ExtendedFlex>
      </ExtendedFlex>
      {
        !invested &&
        <ReitButtons
          id={data.nid}
          dripToggleDisabled={data.dripToggleDisabled}
          reinvestDistributionsURL={data.reinvestDistributionsURL}
          receiveCashDistributionsURL={data.receiveCashDistributionsURL}
          distributionReinvestmentPlanUrl={data.distributionReinvestmentPlanUrl}
          distributionReinvestmentPlanTooltip={data.distributionReinvestmentPlanTooltip}
          smartButtonUrl={data.smartButtonUrl}
          smartButtonText={data.smartButtonText}
          smartButtonMessageText={data.smartButtonMessageText}
          invested={data.transactions.length !== 0}
          dripSetting={data.dripSetting}
          title={data.title}
        />
      }
    </ExtendedFlex>
  );
};

ReitIIContent.propTypes = {
  data: PropTypes.object,
  invested: PropTypes.bool,
};

export default ReitIIContent;
